export const PaymentListWithPaggination = (state) => {
    return state?.payments?.payments;
};
export const PaymentIsLoading = (state) => {
    return state?.payments?.showLoading;
};
